import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { DELETE_BAKER_USER_MUTATION } from '../graphql/mutations/deleteBakerUser';
import { GET_BAKER_USERS } from '../graphql/queries/getBakerUsers';

interface DeleteBakerUser {
  email: string;
}

export const useDeleteBakerUser = () => {
  const [deleteUserMutation] = useMutation(DELETE_BAKER_USER_MUTATION, {
    refetchQueries: [{ query: GET_BAKER_USERS }]
  });

  const deleteUser = async ({ email }: DeleteBakerUser) => {
    const variables = {
      userDeleteDto: {
        email
      }
    };

    try {
      await deleteUserMutation({ variables });
      toast.success('User deleted successfully!');
      return { error: null };
    } catch (error) {
      toast.error('There was an error deleting the user.');
      return { error };
    }
  };

  return { deleteUser };
};
